<template>
    <card>
      <template slot="header">
        <h3 class="card-title">Employee Payslip</h3>
     </template>
       <div class="row">
            <div class="col-md-8">
                <nav class="row">
                    <ol class="breadcrumb arr-right bg-breadcrum">
                        <li class="breadcrumb-item">
                            <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                        </li>
                        <li class="breadcrumb-item active">Employee Payslip</li>
                    </ol>
                </nav>
            </div>
        </div>
       <hr style="margin-top:-10px"/>
          <div class="row">
              <div class="col-md-6">
                  <p><i class="fa fa-search"></i> Search Employee</p>
                  <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
               </div>
              <div class="col-md-2">
                  <p><i class="fa fa-filter"></i> Filter By Year</p>
                  <select v-model="filter_by_year" @change="getYear" class="form-control" required>
                    <option value="">Default</option>
                    <option v-for="year in years(2019)">{{ year }}</option>
                  </select>
               </div>
             <div class="col-md-2">
                    <div class="form-group">
                       <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                       <select v-model="page_limit" class="form-control" required>
                          <option value="">Default</option>
                          <option value="2">2</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                       </select>
                    </div>
             </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                    <select v-model="order_by" class="form-control" required>
                        <option value="">Default</option>
                        <option value="1">ASC</option>
                        <option value="-1">DESC</option>
                    </select>
                  </div>
                </div>               
          </div>
       <hr>
      <!-- PAGINATION -->
      <b-pagination
          v-model="curentPage"
          :total-rows="items.length"
          :per-page="perPage"
          aria-controls="my-table"
          align="right"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          ></b-pagination>
      <!-- END PAGINATION -->
      <hr>
       <div class="table-responsive ">
          <table class="table table-striped table-hover " v-loading="loading">
            <thead>
              <tr>
                  <th width="20">#</th>
                  <th width="100">Employee Id</th>
                  <th width="200">Full Name</th>
                  <th width="150">Position</th>
                  <th width="100">Hired Date</th>
                  <th width="50">Status</th>
                  <th width="150">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item,index in computedRequest">
                  <template v-if="item === 'no data found'">
                      <td colspan="100%">
                          <h4><i class="fa fa-database"></i> Empty Records ...</h4>
                      </td>
                  </template>
                  <template v-else>
                      <td>{{index + 1}}</td>
                      <td>{{item.emp_id}}</td>
                      <td><b>{{item.full_name}}</b></td>
                      <td>{{item.position_name | capitalize}}</td>   
                      <td>{{ getDate(item.employment_date)}}</td>
                      <td>
                        <span v-if="item.status == 'regular'">
                         <i class="fa fa-flag text-success"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'probationary'">
                         <i class="fa fa-flag text-info"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'trainee'">
                         <i class="fa fa-flag text-warning"></i>&nbsp;{{item.status}}
                         </span>
                      </td>
                      <td>
                          <router-link :to="{name: 'uploadPayslip', params: { id: item.id }}" class="btn-primary btn mr-xl-2 my-3">
                              <div><i class="fa fa-upload"></i>&nbsp;Upload Payslip</div>
                          </router-link>                                                       
                      </td>
                    </template>
                  </tr>
            </tbody>
        </table>
        <br/>
          <!-- PAGINATION NATIVE WAY -->
          <div class="row">
            <div class="col-md-6">
              <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
            </div>
            <div class="col-md-6">
              <b-pagination
                  v-model="curentPage"
                  :total-rows="items.length"
                  :per-page="perPage"
                  aria-controls="my-table"
                  align="right"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  ></b-pagination>
            </div>
        </div>
     <!-- END PAGINATION -->
        </div>  
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
components: {
  Card,
},

 data() {
    return {
      items: [],
      order_by: '',
     //PAGINATION
      page_limit: '',
      filter_by_year:'',
      start_page: 1,
      loading: true,
      perPage: 1000,
      curentPage: 1,
      search: ''
    }
  },

  created: function () {
    setTimeout(() => {
      this.loading = false;
    }, 300);
  },

  beforeMount: function () {
    this.getAllEmployees();
  },

  methods: {
    //LIST OF EMPLOYEE BASE SA CONTRACTS AND MEMOS LIST
     getYear(){
        if(this.filter_by_year == ''){
           this.get_employees()
        }else{
           axios.get('api/contractsmemo/filteremployee/' + this.filter_by_year)
           .then(response => {
            this.items = response.data;
           })
          .catch(error => {
            console.log(error.response)
          });
        } 
      },

    getAllEmployees() {
        axios.get('api/contractsmemo').then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error.response)
        });
    },

  },
  computed: {
    // PAGINATION
    offset() {
      return ((this.start_page - 1) * this.page_limit);
    },

    limit() {
      return ((this.offset + this.page_limit));
    },
    total_item() {
           return this.items.length
    },  
    computedRequest() {
      let filtered = this.items
       // USE IN PAGINATION 
      let start = (this.curentPage - 1) * this.perPage
      let end = this.curentPage * this.perPage
      filtered = filtered.slice(start, end)

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(
            item => item.full_name.toLowerCase().indexOf(this.search) > -1
          );
          return filtered
        }
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
          return filtered
        }

      } else {
        filtered = 0
      }

      return filtered
    }
  },


}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-payroll/todo-payslip.vue